export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';
export const CANADIAN_TAX_BREAKDOWNS_GATE = 'Commerce:CanadaSalesTax';
export const STRIPE_CONFIRMATION_TOKEN_GATE = 'Checkout:StripeConfirmationToken';
export const ZERO_PERCENT_TAX_GATE = 'CPQ:PLI:ZeroPercentTax';